import React from "react";
import { Link } from "react-scroll";

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-link-container">
        <div className="footer-brand">
          <img src="/primary-logo.png" alt="Tech With Manny" className="footer-logo" />
          <span className="footer-brand-text">Tech With Manny</span>
        </div>
        <div className="footer-items">
          <ul>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="heroSection" className="text-md">
                Home
              </Link>
            </li>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="MyPortfolio" className="text-md">
                Portfolio
              </Link>
            </li>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="AboutMe" className="text-md">
                About Me
              </Link>
            </li>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="Newsletter" className="text-md">
                Subscribe
              </Link>
            </li>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="testimonial" className="text-md">
                Testimonials
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-social-icon">
          <ul>
            <li>
              <a href="https://www.linkedin.com/in/nsuku-mathebula-76856ab0/" className="social-btn" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.447-2.136 2.943v5.663H9.35V9h3.414v1.561h.049c.476-.9 1.637-1.852 3.37-1.852 3.606 0 4.271 2.373 4.271 5.457v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.114 20.452H3.558V9h3.556v11.452z"/>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://github.com/mathebulansuku" className="social-btn" target="_blank" rel="noreferrer" aria-label="GitHub">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M12 .5C5.73.5.9 5.33.9 11.6c0 4.87 3.15 8.99 7.51 10.45.55.1.75-.24.75-.53 0-.27-.01-.99-.02-1.94-3.05.66-3.7-1.47-3.7-1.47-.5-1.29-1.22-1.64-1.22-1.64-.99-.67.08-.66.08-.66 1.1.08 1.68 1.13 1.68 1.13.98 1.68 2.57 1.2 3.2.92.1-.71.38-1.2.69-1.47-2.43-.28-4.98-1.21-4.98-5.36 0-1.18.42-2.14 1.11-2.9-.11-.28-.48-1.41.11-2.94 0 0 .9-.29 2.95 1.11.86-.24 1.78-.36 2.7-.36.92 0 1.84.12 2.7.36 2.05-1.4 2.95-1.11 2.95-1.11.59 1.53.22 2.66.11 2.94.69.76 1.11 1.72 1.11 2.9 0 4.16-2.56 5.08-5 5.35.39.33.73.98.73 1.98 0 1.43-.01 2.58-.01 2.93 0 .29.2.64.76.53 4.35-1.46 7.5-5.58 7.5-10.45C23.1 5.33 18.27.5 12 .5Z"/>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/" className="social-btn" target="_blank" rel="noreferrer" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5a5 5 0 1 0 .001 10.001A5 5 0 0 0 12 7zm6-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM12 9.5A3.5 3.5 0 1 1 8.5 13 3.5 3.5 0 0 1 12 9.5z"/>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://x.com/" className="social-btn" target="_blank" rel="noreferrer" aria-label="X">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M3 3h4.5l5 6.5L17.5 3H21l-7 9 7 9h-4.5l-5-6.5L6.5 21H3l7-9z"/>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <hr className="divider" />
      <div className="footer-content-container">
        <p className="footer-content">© {new Date().getFullYear()} Tech With Manny</p>
        <div className="footer-social-icon">
          <ul>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="Privacy_Policy" className="text-sm">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="Terms_of_Service" className="text-sm">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link activeClass="navbar-active-content" spy={true} smooth={true} offset={-70} duration={500} to="Cookies_Settings" className="text-sm">
                Cookies Settings
              </Link>
            </li>
          </ul>
        </div>
        <Link to="heroSection" smooth={true} duration={500} className="back-to-top" aria-label="Back to top">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 5l7 7-1.4 1.4L13 8.8V19h-2V8.8L6.4 13.4 5 12z"/>
          </svg>
        </Link>
      </div>
    </footer>
  );
}

export default Footer;
